<template>
  <div class="system-test">
    <div>
      time on client side (UTC)<br>
      {{nowISOStr}}
    </div>
    <div>
      time on client side<br>
      {{nowStr}}
    </div>
    <div>
      timezone offset on client side<br>
      {{timezoneOffset}}
    </div>

    <hr>

<!--
    <loading-indicator
      v-if="isLoading"
    />

    <p
      v-if="testTime !== null"
    >
      test time<br>
      {{testTime}}<br>
      {{testTime | getMomentStr}}
    </p>
-->

    <b-form-datepicker
      v-model="testTimeDateStr"
      :start-weekday="MONDAY"
      class="mb-2"
    />

    <b-form-timepicker
      v-model="testTimeTimeStr"
    />
    test time (local)<br>
    {{testTimeMoment.toString()}}<br>
    {{testTimeMomentStamp | getMomentStr}}<br><br>

    test time (UTC)<br>
    {{testTimeMoment.toISOString()}}<br><br>

    test time (stamp)<br>
    {{testTimeMomentStamp}}

    <hr>

    <table class="mb-2">
      <tr>
        <td class="pb-1 pr-1">Param 1</td>
        <td class="pb-1"><input v-model="param1" class="form-control"></td>
      </tr>
      <tr>
        <td class="pb-1 pr-1">Param 2</td>
        <td class="pb-1"><input v-model="param2" class="form-control"></td>
      </tr>
      <tr>
        <td class="pr-1">Param 3</td>
        <td><input v-model="param3" class="form-control"></td>
      </tr>
    </table>

    <b-button @click="doAction(1)" class="mb-1">Do action 1</b-button><br>
    <b-button @click="doAction(2)" class="mb-1">Do action 2</b-button><br>
    <b-button @click="doAction(3)">Do action 3</b-button>
  </div>
</template>

<script>
import notifier from '../notifier.js';
import { HTTP } from '../http-common.js';

import { convertMomentToDataStr              } from '../util.js';
import { convertMomentToTimeStr              } from '../util.js';
import { convertDataStrAndTimeStrToLocalData } from '../util.js';

export default {
  name: 'SystemTest',

  data() {
    const now = new Date();
    const nowDateStr = convertMomentToDataStr(now);
    const nowTimeStr = convertMomentToTimeStr(now);

    const nowISOStr = now.toISOString();

    return {
      MONDAY: 1,

      nowISOStr: nowISOStr,
      nowStr: now.toString(),
      timezoneOffset: now.getTimezoneOffset(),

      testTimeDateStr: nowDateStr,
      testTimeTimeStr: nowTimeStr,

      param1: '',
      param2: '',
      param3: '',
    };
  },

  computed: {
     /** @returns {?Date} */
    testTimeMoment() {
      const m = convertDataStrAndTimeStrToLocalData(this.testTimeDateStr, this.testTimeTimeStr);
      return m;
    },

    /** @returns {number} */
    testTimeMomentStamp() {
      return Math.floor(this.testTimeMoment.getTime() / 1000);
    }
  },

  created() {
    /*
    this.isLoading = true;

    const url = '/test_time';
    HTTP.get(url)
    .then(response => {
      this.isLoading = false;

      const data = response.data.data;
      if(data === null) {
        notifier.showError('Invalid server response. data === null.', {sender: this});
        return;
      }

      this.testTime = data;
    })
    .catch(e => {
      this.isLoading = false;
      notifier.showError(e.response.data);
    });
    */
  },

  methods: {
    /**
     * @param {number} n
     */
    doAction(n) {
      notifier.deleteSenderNotifications(this);

      const data = new FormData();
      data.set('n', n.toString());

      const param1 = this.param1.trim();
      if(param1.length > 0) {
        data.set('param1', param1);
      }

      const param2 = this.param2.trim();
      if(param2.length > 0) {
        data.set('param2', param2);
      }

      const param3 = this.param3.trim();
      if(param3.length > 0) {
        data.set('param3', param3);
      }

      console.log('Action started.');
      HTTP.post('/test/action/do', data)
      .then(() => {
        notifier.showSuccess(`Action ${n} done.`);
      })
      .catch(err => {
        notifier.showError(err, {sender: this});
      });
    },
  },
};
</script>

<style scoped>
  .system-test > div {
    margin-bottom: 0.8em;
  }
</style>
